import {
  FETCH_CHATBOT_CONFIG,
  CREATE_CHATBOT_CONFIG,
  UPDATE_CHATBOT_CONFIG,
  DELETE_CHATBOT_CONFIG,
  SET_CHATBOT_LOADING,
  SET_CHATBOT_ERROR
} from '../Actions/AI/type';

const initialState = {
  loading: false,
  error: null,
  config: null
};

const aichatbotReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHATBOT_LOADING:
      return { ...state, loading: true };

    case SET_CHATBOT_ERROR:
      return { ...state, loading: false, error: action.payload };

    case FETCH_CHATBOT_CONFIG:
    case CREATE_CHATBOT_CONFIG:
    case UPDATE_CHATBOT_CONFIG:
      return { ...state, loading: false, error: null, config: action.payload };

    case DELETE_CHATBOT_CONFIG:
      return { ...state, loading: false, error: null, config: null };

    default:
      return state;
  }
};

export default aichatbotReducer;
